import { useSeo } from '../lib/seo';
import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import api from '../lib/api';
import NewsletterSignup from '../components/NewsletterSignup';

export default function DigestPage() {
  useSeo(
    'The Week Ahead in Leicestershire | Go Leicestershire',
    "Our editors' weekly digest of the best things happening across Leicestershire — events, weather and picks for the week ahead."
  );
  const [latest, setLatest] = useState(null);
  const [archive, setArchive] = useState([]);
  useEffect(() => {
    api.get('/digest/latest').then((r) => setLatest(r.data));
    api.get('/digest').then((r) => setArchive(r.data.items));
  }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-16">
      <div className="label text-heritage mb-3 inline-flex items-center gap-2"><Sparkles size={14}/> This Weekend</div>
      <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mb-12">The weekend digest.</h1>

      {latest?.title ? (
        <article className="bg-white border border-charcoal/10 rounded-[2rem] p-10 lg:p-16">
          <div className="label text-charcoal/50 mb-4">{latest.week_starting ? new Date(latest.week_starting).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : ''}</div>
          <h2 className="font-display text-4xl lg:text-5xl leading-tight mb-6">{latest.title}</h2>
          {latest.intro && <p className="text-2xl font-display text-charcoal/70 leading-snug mb-8">{latest.intro}</p>}
          <div className="text-lg whitespace-pre-wrap leading-relaxed text-charcoal/90">{latest.body}</div>
          {latest.weather_summary && <div className="mt-10 pt-8 border-t border-charcoal/10 label text-charcoal/50">Weather: {latest.weather_summary}</div>}
        </article>
      ) : (
        <div className="bg-stone/50 border border-charcoal/10 rounded-[2rem] p-12 text-center">
          <p className="text-xl font-display text-charcoal/70">Your first weekend digest will appear here. Head to the admin dashboard and tap "Generate" to write this Friday's edition.</p>
        </div>
      )}

      <div className="mt-16">
        <h3 className="font-display text-2xl mb-6">Get it Friday morning</h3>
        <NewsletterSignup source="digest-page" />
      </div>

      {archive.length > 1 && (
        <div className="mt-20">
          <h3 className="font-display text-3xl mb-8">Past digests</h3>
          <div className="space-y-3">
            {archive.slice(1).map((d) => (
              <div key={d.id} className="bg-white border border-charcoal/10 rounded-2xl p-6">
                <div className="label text-charcoal/50 mb-1">{new Date(d.week_starting).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</div>
                <h4 className="font-display text-xl">{d.title}</h4>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
